__turbopack_context__.v({
  "paragraph": "Paragraph-module__zJdMNa__paragraph",
});
